import React from 'react';
import PageContainer from '../../components/PageComponents/layouts/PageContainer';
import SafetyNav from '../../components/SafetyNav';
import List from './List';

const breadcrumbs = [{ label: 'Safety Config', isActive: true }];

const SafetyConfig = () => (
  <PageContainer heading="SAFETY CONFIG" breadcrumbs={breadcrumbs}>
    <SafetyNav />
    <List />
  </PageContainer>
);

export default SafetyConfig;
